import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity TreeMarkings


export interface TreeMarking {
    id: ID;

    
    cuttingId: ID;

    
    storageId: ID;

    
    timberTypeId: ID;

    
    volume: number;

    
    scopeGroupId: ID;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        volumeFrom?: number,
            volumeTo?: number,
        
    
    

            timberTypeId: ID[],
        
    
    

            storageId?: ID,
        
    
    



        cuttingIdRefs?: ID[],
        storageIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateTreeMarking {
    
    
    storageId: ID;

    
    timberTypeId: ID;

    
    volume: number;

    
    }


export interface UpdateTreeMarking {
    
    
    
    
    volume: number;

    
    }

export interface PresentationTreeMarkingRequest {
    list: ListRequest,
    filter: {
        timberTypeId: ID,
        timberTypeIdOr: boolean,
        volume: number,
        volumeOr: boolean,
        cuttingIdRefs?: ID[],
        storageIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryTreeMarking {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: TreeMarking): PrimaryTreeMarking | undefined {
        return entity ? new PrimaryTreeMarking(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryTreeMarking {
        return new PrimaryTreeMarking(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryTreeMarking {
        let vals = path?.split('/');
        return new PrimaryTreeMarking(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryTreeMarking[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: TreeMarking): string {
    let fields = entity ? [
    entity.timberTypeId,
            entity.volume,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityTreeMarking {
    id: PrimaryTreeMarking;
    data: UpdateTreeMarking;


    constructor(id: PrimaryTreeMarking, data: UpdateTreeMarking) {
        this.id = id;
        this.data = data;
    }
}
